import { Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'download-portal-loader',
    templateUrl: './loader.component.html',
    styles: '',
    imports: [MatProgressSpinner],
})
export class LoaderComponent {
  @Input() isLoading: boolean = true;
}
